import { HOUR_MS, type WeatherHistory, type WeatherHour, type WeatherNow } from './types';

const LINEAR_KEYS = [
  'temperatureC', 'humidity', 'visibilityM', 'precipitationMm', 'rainMm', 'snowfallCm',
  'cloudLow', 'cloudMid', 'cloudHigh', 'windSpeedMs', 'gustMs',
] as const;

function strip(hour: WeatherHour): WeatherNow {
  const now: Partial<WeatherHour> = { ...hour };
  delete now.time;
  return now as WeatherNow;
}

export function weatherAt(history: WeatherHistory, instant: number): WeatherNow {
  const { hours } = history;
  const first = hours[0];
  const last = hours[hours.length - 1];
  if (!first || !last) throw new Error('weatherAt: empty history');
  if (instant <= first.time) return strip(first);
  if (instant >= last.time) return strip(last);

  const i = Math.min(hours.length - 2, Math.floor((instant - first.time) / HOUR_MS));
  const a = hours[i]!;
  const b = hours[i + 1]!;
  const f = (instant - a.time) / (b.time - a.time);

  const out = strip(f < 0.5 ? a : b);
  for (const k of LINEAR_KEYS) out[k] = a[k] + (b[k] - a[k]) * f;
  const dDir = ((((b.windDirDeg - a.windDirDeg) % 360) + 540) % 360) - 180;
  out.windDirDeg = (((a.windDirDeg + dDir * f) % 360) + 360) % 360;
  return out;
}
